import {IDataModelTypeConfig} from "frontend/dataModels/types/IDataModelTypeConfig";
import {markRaw} from 'vue'
import {Vehicle} from 'frontend/vehicles'
import {COLUMNS_CONFIG, DEFAULT_COLUMNS, FIELDS, SUBSCRIPTIONS} from 'frontend/tracker-devices/tracker-device-table-helpers'

export const TrackerDeviceDataModelTypeConfig: IDataModelTypeConfig = {
  fields: FIELDS,
  subscriptions: SUBSCRIPTIONS,
  defaultColumns: DEFAULT_COLUMNS,
  columnConfig: COLUMNS_CONFIG,
}